/**
 * SSE Configuration
 *
 * Reads SSE-related environment variables.
 * Isolated in its own module so it can be mocked in Jest tests
 * (import.meta.env is not supported by ts-jest).
 */

export const SSE_CONFIG = {
  /**
   * Whether SSE real-time updates are enabled.
   * Set VITE_SSE_ENABLED='false' to disable.
   */
  isEnabled: import.meta.env.VITE_SSE_ENABLED !== 'false',
} as const;
